import { fetch } from '../request'
import type { IResponse } from '../interface'
import type { StorageDetail } from '../interface/storage'

/**
 * 用户存储空间详情
 * @param
 * @returns
 */
export const fetchStorageInfo = () => {
  return fetch<IResponse<StorageDetail>>('/storage/repository/detail/', {
    method: 'GET',
  })
}

/**
 * 团队成员存储使用记录
 * @param
 * @returns
 */
export const fetchMembersStorage = (params: any) => {
  return fetch('/storage/rank/', {
    method: 'GET',
    params,
  })
}
